import {
  ENV,
  ROOT_URL,
  API_BLOB_URL,
  LORRI_APPLICATION_SERVICES,
  API_INTERNAL_API_URL,
  APPLICATION_NAME,
  CLIENT_REDIRECT_BASE,
  ADB2C_CONFIG_TENANT_REDIRECT_URL,
  COMPANY_SIDE_URL,
  MIXPANEL_TOKEN,
  GOOGLE_ID,
  API_LOGO_BASE_URL,
  API_STORAGE,
  IS_PROD
} from "./env.config";

const BaseUrl = `${ROOT_URL}/api/apilorri`;
const UserBaseUrl = `${ROOT_URL}/api/apiuser`;
const BlobUrl = API_BLOB_URL;
const lorriapplicationservices_Url = LORRI_APPLICATION_SERVICES;
const AuctionBaseUrl = `${ROOT_URL}/`;
const InternalAPIURL = API_INTERNAL_API_URL;
const MixPanelApplicationname = APPLICATION_NAME;
const EmailTemplate = `${ROOT_URL}/api/spot/editble_emails?`;
const LogisticsPlanningBaseUrl = `${ROOT_URL}/api/planning/`;
const ClientRedirectUrl = CLIENT_REDIRECT_BASE;
const procureRedirectUrl = ADB2C_CONFIG_TENANT_REDIRECT_URL;
const environment = ENV;
const CompanySideUrl = COMPANY_SIDE_URL;
const lorriApplicationService = LORRI_APPLICATION_SERVICES;

const RPT_BASE_URL = "https://api-rpt.lorri.in/api";

let mixpanelTokenId;

if (IS_PROD) {
  mixpanelTokenId = MIXPANEL_TOKEN;
} else {
  mixpanelTokenId = "no-mixpanel";
}

export const Urls = {
  logURL: `${BaseUrl}/log`,
  download_report: `${BaseUrl}`,
  planning: `${LogisticsPlanningBaseUrl}`,
  CompanySideUrl: CompanySideUrl,
  logURLUpdated: `https://lorriservice.azurefd.net/api/log`,
  uploadService: `${lorriapplicationservices_Url}/fileupload`,
  uploadServiceNew: `${BaseUrl}/fileuploadnew`,
  fileService: `${lorriApplicationService}/fileupload`,
  getActiveprocurement: `${AuctionBaseUrl}api/procurements`,
  gettransporterdetails: `${BaseUrl}/procurements/procurement_id/`,
  currentProcurement: `${AuctionBaseUrl}api/procurements/procurement_id/`,
  blobuploads: `https://fileuploadservice.azurewebsites.net/api/${BlobUrl}`,
  procurement_uploads_list: `${AuctionBaseUrl}api/procurements`,
  blobuploads2: `https://fileuploadservice.azurewebsites.net/api/`,
  shortlistEmail: `${InternalAPIURL}/api/procurement_emails`,
  firebase_token: `${UserBaseUrl}/firebase_token?stage=${
    environment === "staging" || environment === "development"
      ? "stage"
      : "production"
  }`,

  Email: {
    procurementEmail: `${InternalAPIURL}/api/procurement_emails`,
  },
  Transporters: {
    Get: `${UserBaseUrl}/transporter_details`,
    SendgridEmail: `${BaseUrl}/trigger_email`,
    Shortlist: `${BaseUrl}/shortlists `,
  },
  shortlistSMS: `${AuctionBaseUrl}/api/procurement_sms`,
  GetCurrentUser: `${UserBaseUrl}/user_details`,
  Autocomplete: {
    Get: {
      getlist: `${UserBaseUrl}/autocomplete`,
      getTransporterName: `${UserBaseUrl}/transporter_dataV2`,
    },
  },
  user_data: `${UserBaseUrl}/user`,
  auction: `${AuctionBaseUrl}/api/tpmpauction`,
  auctionlorri: `${AuctionBaseUrl}/api/lorriauction`,
  auctionlorri1: `${AuctionBaseUrl}/api/`,
  createProcurement: `${AuctionBaseUrl}/api/procurements`,
  procureaddlane: `${AuctionBaseUrl}/api/ratecard?procurement_id`,
  auctionUrl: `${AuctionBaseUrl}/api`,
  lotDevLink: `https://auctiondevelopment.azurewebsites.net/api`,
  rateCardUrl: `${AuctionBaseUrl}/api/ratecard?field=update_roundstatus&procurement_id`,
  // worldAPI: "https://timeapi.io/api/time/current/zone?timeZone=Asia%2FKolkata",
  worldAPI: `${AuctionBaseUrl}/api/current_timestamp`,
  advancedauctionlorri: `${AuctionBaseUrl}/api/lorriadvancedauction`,
  messages: `${AuctionBaseUrl}/api`,
  policy: `${BaseUrl}/user/policy`,
  companyProfile: `${UserBaseUrl}/company_profile`,
  procurements: `${AuctionBaseUrl}/api/procurements`,
  updateRFQAttachments: `${AuctionBaseUrl}api/update_attachments`,
  filters: `${BaseUrl}/filters`,
  mixpanelappname: `${MixPanelApplicationname}`,
  transporter_fields: `${UserBaseUrl}`,
  email_template: `${EmailTemplate}`,
  clientSideLogin: `${ClientRedirectUrl}?url=${procureRedirectUrl}`,
  TransporterProfile: `https://portal.lorri.in/profile`,
  gaId: GOOGLE_ID,
  FileUrl: API_LOGO_BASE_URL,
  APIStorage: API_STORAGE,
  ClientRedirect: CLIENT_REDIRECT_BASE,
  procurement_chat: `${AuctionBaseUrl}/api/`,
  procurementLspRateCard: `${AuctionBaseUrl}/api/ratecard`,
  approvalControl: `${BaseUrl}/approval_control`,
  mixpanelId: mixpanelTokenId,
  LorriLogoLogin:
    "https://rnrdeploynew.blob.core.windows.net/staticimages/LoRRI_screen_zero-min.png",

  rpt_base_url: RPT_BASE_URL,
};
